import API from "@lib/api";
import { BaseApi } from "@api";
import { FakerUtils } from "@utils";
import { Messages } from "@interfaces";

import { IRecurringInvoice } from "../interfaces";

export class RecurringPurchaseInvoicesApi extends BaseApi {
  protected static readonly api = API({
    namespace: "FacturasComprasRecurrentes",
  });
  protected static readonly filterApi = API({ namespace: "Filtro" });
  protected static readonly messages: Messages<
    typeof RecurringPurchaseInvoicesApi
  > = {
    createRecurringPurchaseInvoice: {
      loading: "Creando una nueva factura de compra...",
      success: "Factura de compra creada correctamente.",
      error: (error) => `Hubo un error al crear la factura de compra: ${error}`,
    },
  };

  // public static async getAll(): Promise<IRecurringInvoice[]> {
  //   const result = await this.api.get("GetAll");
  //   return result.data;
  // }

  public static async getAll(): Promise<IRecurringInvoice[]> {
    const result = FakerUtils.getAllRecurringInvoices();
    return result.data;
  }

  //   public static async getAllByFilter(
  //     filterId: number,
  //   ): Promise<IRecurringInvoice[]> {
  //     const result = await this.filterApi.get<IRecurringInvoice[]>(
  //       `FiltroPorArea/${filterId}`,
  //     );
  //     return result.data;
  //   }

  public static async createRecurringPurchaseInvoice(
    data: object,
  ): Promise<IRecurringInvoice> {
    const result = await this.api.post("Create", data);
    return result.data;
  }
}
